<template>
  <el-dialog
      :visible.sync="visible"
      :title="title"
      :width="width"
      :before-close="handleClose"
      class="complaint-progress-modal"
      :close-on-click-modal="false"
  >
    <!-- 头部信息卡片 -->
    <div class="header-card">
      <el-card class="event-card">
        <div slot="header" class="event-status">
          <i class="el-icon-loading"></i>
          <span>处理中</span>
        </div>
        <div class="event-content">
          <h4 class="community-name">昱光苑小区名称</h4>
          <p class="event-desc">昱光苑小区3栋发生高空抛物告警，请及时安排相关负责人员前往事发地查看，记录并核查相关人员。</p>
          <div class="event-meta">
            <span class="event-time">事件时间：2025-01-01 12:19</span>
            <span class="handle-limit">处理时限：24小时</span>
            <span class="handler">处理人：王物业</span>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 处理进度时间线 -->
    <div class="progress-timeline">
      <el-timeline>
        <el-timeline-item
            v-for="(item, index) in processingSteps"
            :key="index"
            :timestamp="item.time"
            :placement="index === 0 ? 'top' : 'bottom'"
            :color="item.color || '#409EFF'"
        >
          <div class="timeline-content">
            <p class="content-text">{{ item.content }}</p>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>

    <!-- 介入处理部分 -->
   <div v-if="intervention" class="intervention-section">
     <div class="intervention-header">
       <span class="intervention-time">{{ intervention.time }}</span>
       <span class="intervention-tag">介入处理</span>
     </div>

     <div class="intervention-details">
        <div class="detail-item">
          <span class="detail-label">标题：</span>
          <span class="detail-value">{{ intervention.title }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">内容：</span>
          <span class="detail-value">{{ intervention.content }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">要求完成时间：</span>
          <span class="detail-value">{{ intervention.requiredCompletionTime }}</span>
        </div>
     </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ComplaintProgressModal',
  props: {
    // 控制弹窗显示/隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 弹窗标题
    title: {
      type: String,
      default: '处理进度'
    },
    // 弹窗宽度
    width: {
      type: String,
      default: '60%'
    },
    // 事件信息
    eventInfo: {
      type: Object,
      default: () => ({
        type: '投诉',
        community: '昱光苑小区',
        property: '王物业',
        description: '昱光苑小区3栋发生高空抛物告警，请及时安排相关负责人员前往事发地查看，记录并核查相关人员。',
        eventTime: '2025-01-01 12:19',
        processingTimeLimit: '24小时',
        handler: '王物业',
        status: 'completed' // completed, processing, pending
      })
    },
    // 处理步骤
    processingSteps: {
      type: Array,
      default: () => [
        {
          time: '2025-01-01 12:25',
          content: '物业值班人员前往事发地点查看，确认高空抛物物品为生活垃圾，未造成财产损坏，未造成人员伤亡，抛落物已拍照取证并清理。',
          color: '#67C23A'
        },
        {
          time: '2025-01-01 12:40',
          content: '安全主管调取监控信息，并向住户询问已确认抛物人员。'
        },
        {
          time: '2025-01-01 13:00',
          content: '安全主管已收集证据材料，确认责任方，并对业主进行警示教育。'
        }
      ]
    },
    // 介入处理信息
    intervention: {
      type: Object,
      default: () => ({
        time: '2025-01-01 12:40',
        title: '标题描述',
        content: '内容描述',
        requiredCompletionTime: '2025-08-20'
      })
    }
  },
  computed: {
    // 根据状态确定标签类型
    statusType() {
      switch (this.eventInfo.status) {
        case 'completed':
          return 'success'
        case 'processing':
          return 'warning'
        case 'pending':
          return 'info'
        default:
          return 'success'
      }
    },
    // 根据状态确定显示文本
    statusText() {
      switch (this.eventInfo.status) {
        case 'completed':
          return '已完成'
        case 'processing':
          return '处理中'
        case 'pending':
          return '待处理'
        default:
          return '已完成'
      }
    },
    // 根据状态确定图标
    statusIcon() {
      switch (this.eventInfo.status) {
        case 'completed':
          return 'el-icon-check'
        case 'processing':
          return 'el-icon-loading'
        case 'pending':
          return 'el-icon-time'
        default:
          return 'el-icon-check'
      }
    }
  },
  methods: {
    // 关闭弹窗时触发
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.complaint-progress-modal {
  --primary-color: #409EFF;
  --success-color: #67C23A;
  --text-primary: #FFFFFF;
  --text-secondary: rgba(255, 255, 255);
  --bg-card: rgba(30, 58, 138);
  --border-color: rgba(4, 13, 15);
}

.event-card {
  background-color: transparent;
  border: 1px solid #2a4361;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 50px;
  font-size: 16px;
}

.event-card::v-deep .el-card__header {
  border-bottom: none !important;
  padding: 0 0 0 0;
  background: linear-gradient(to right, rgba(15, 61, 58, 0.5) 0%, rgba(15, 61, 58, 0) 100%);
}

.event-card::v-deep .el-card__body {
  padding: 0;
}

.event-status {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);

}

.event-status i {
  margin-right: 5px;
}

/*.processing .event-status {*/
/*  background-color: #13c2c2;*/
/*  color: #fff;*/
/*}*/

.community-name {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.event-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 12px;
  color: #86909c;
}

.event-content {
  padding: 15px;
}

.status-tag {
  margin-bottom: 16px;
}

.event-title {
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.type-label {
  color: var(--primary-color);
}

.separator {
  margin: 0 8px;
  color: var(--text-secondary);
}

.community, .property {
  color: var(--text-secondary);
}

.event-desc {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 16px;
  padding-left: 2px;
}

.event-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
}

.meta-item {
  color: var(--text-secondary);
  font-size: 12px;
  display: flex;
  align-items: center;
}

.meta-label {
  color: rgba(255, 255, 255);
  margin-right: 4px;
}

.progress-timeline {
  margin-bottom: 20px;
}

/deep/ .el-timeline-item__timestamp {
  color: var(--text-secondary);
  font-size: 12px;
}

.timeline-content {
  margin-top: 4px;
}

.content-text {
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0;
}

.intervention-section {
  border-left: 2px solid var(--primary-color);
  padding-left: 16px;
  margin-bottom: 10px;
}

.intervention-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.intervention-time {
  color: var(--primary-color);
  font-size: 12px;
  margin-right: 10px;
}

.intervention-tag {
  color: var(--primary-color);
  font-size: 12px;
  background-color: rgba(64, 158, 255, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
}

.intervention-details {
  margin-left: 2px;
}

.detail-item {
  color: var(--text-secondary);
  font-size: 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
}

.detail-label {
  color: rgba(255, 255, 255);
  margin-right: 4px;
  min-width: 50px;
}

.dialog-footer {
  text-align: center;
}

/deep/ .el-dialog {
  background-color: rgba(4, 13, 15);
  border: 1px solid rgba(255, 255, 255,0.8);
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid var(--border-color);
}

/deep/ .el-dialog__title {
  color: var(--text-primary);
}

/deep/ .el-dialog__body {
  color: var(--text-secondary);
  padding: 20px;
}

/deep/ .el-button {
  background-color: rgba(64, 158, 255, 0.2);
  color: var(--primary-color);
  border-color: var(--primary-color);
}

/deep/ .el-button:hover {
  background-color: rgba(64, 158, 255, 0.3);
  color: var(--primary-color);
  border-color: var(--primary-color);
}
</style>
